import { render } from "./paymentwithschedule.vue?vue&type=template&id=2882ea5e&scoped=true"
import script from "./paymentwithschedule.vue?vue&type=script&lang=js"
export * from "./paymentwithschedule.vue?vue&type=script&lang=js"

import "./paymentwithschedule.vue?vue&type=style&index=0&id=2882ea5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2882ea5e"]])

export default __exports__